// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"0b7c8492","307":"9654d03f","318":"5d76c458","433":"179e5bd5","462":"2088dac9","666":"f7991a08","832":"67ebfefa"}[chunkId] + ".chunk.js";
};